import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    StateCityByZipcodeSuccess,
    StateCityByZipcodeFailure,
    TaxCalculationByAddressType1Success,
    TaxCalculationByAddressType1Failure,
    TaxCalculationByAddressType2Success,
    TaxCalculationByAddressType2Failure,
    CreateCustomerSuccess,
    CreateCustomerFailure,
    GetCustomerSuccess,
    GetCustomerFailure,
    checkEmailAvailabilitySuccess,
    checkEmailAvailabilityFailure,
    UpdateCustomerSuccess,
    UpdateCustomerFailure,
    UpdateCustomerSourceSuccess,
    UpdateCustomerSourceFailure,
    EligibilitySuccess,
    EligibilityFailure,
    CouponSuccess,
    CouponFailure,
    PaymentFailure,
    PaymentSuccess,
    PaymentGetSuccess,
    PaymentGetFailure,
    CouponReserveSuccess,
    CouponReserveFailure,
    UpdateSecondaryCustomerFailure,
    UpdateSecondaryCustomerSuccess,
    ReachNumberSignupSuccess,
    ReachNumberSignupFailure,
    ShippmentOrderSuccess,
    ShippmentOrderFailure,
    ResetPasswordSuccess,
    ResetPasswordFailure,
    GetOrderByCustomerIdSuccess,
    GetOrderByCustomerIdFailure,
} from './actions';
import {
    CREATE_CUSTOMER,
    GET_STATE_CITY_BY_ZIPCODE,
    TAX_CALCULATION_BY_ADDRESS_TYPE1,
    TAX_CALCULATION_BY_ADDRESS_TYPE2,
    GET_CUSTOMER,
    UPDATE_CUSTOMER,
    UPDATE_CUSTOMER_SOURCE,
    ELIGIBILITY,
    COUPON,
    PAYMENT,
    PAYMENT_GET,
    COUPON_RESERVE,
    UPDATE_SECONDARY_CUSTOMER,
    CHECK_EMAIL_AVAILBLITY,
    REACH_NUMBER_SIGNUP,
    SHIPPMENT_ORDER,
    RESET_PASSWORD,
    GET_ORDER_BY_CUSTOMER_ID,
} from './actionTypes';
import apiJunction from '../../utils/api';
import { store } from 'react-notifications-component';
// import { paymentAddress } from '../../config';
import { domainName, domainMap, version } from '../../config';
import ApiEndPoints from '../../utils/ApiEndPoints';

export interface ResponseGenerator {
    config?: any;
    data?: any;
    headers?: any;
    request?: any;
    status?: number;
    statusText?: string;
}

// get city.state by zipcode
function* stateCityByZipcode(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            // url: `/provsvc/${version}/zip/${action.payload.countryCode}/${action.payload.zipcode}`,
            url: `/provsvc/${version}/mdn/zipcode/availability/${action.payload.zipcode}`,
        });
        yield put(
            StateCityByZipcodeSuccess({
                stateCityByZipcode: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            StateCityByZipcodeFailure({
                errorStateCityByZipcode: e.response && e.response.data,
            }),
        );
        store.addNotification({
            message: 'Please enter a valid zipcode',
            type: 'danger',
            insert: 'top',
            container: 'top-full',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
                duration: 3000,
                showIcon: true,
            },
        });
    }
}

// Calculate tax by address type 1
function* taxCalculationByAddressType1(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/taxsvc/${version}/taxes/${action.payload.countryCode}`,
            body: action.payload.data,
        });
        yield put(
            TaxCalculationByAddressType1Success({
                taxCalculationByAddressType1: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            TaxCalculationByAddressType1Failure({
                errorTaxCalculationByAddressType1: e.response && e.response.data,
            }),
        );
    }
}

// Calculate tax by address type 2
function* taxCalculationByAddressType2(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url:
                domainName === domainMap.T2
                    ? `/taxsvc/${version}/taxes/${action.payload.countryCode}`
                    : `/taxsvc/${version}/taxes/${action.payload.countryCode}`,
            body: action.payload.data,
        });
        yield put(
            TaxCalculationByAddressType2Success({
                taxCalculationByAddressType2: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            TaxCalculationByAddressType2Failure({
                errorTaxCalculationByAddressType2: e.response && e.response.data,
            }),
        );
    }
}

// Create customer
function* createCustomer(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `authsvc/${version}/${action.payload.countryCode}/customers`,
            body: action.payload.data,
        });
        yield put(
            CreateCustomerSuccess({
                createCustomer: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            CreateCustomerFailure({
                errorCreateCustomer: e.response
                    ? e.response.data
                    : { status: 'FAILURE', message: 'Some error occurred!' },
            }),
        );
        store.addNotification({
            message: e.response && e.response.data && e.response.message,
            type: 'danger',
            insert: 'top',
            container: 'top-full',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
                duration: 3000,
                showIcon: true,
            },
        });
    }
}

//shippment order

function* shipmentOrder(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${ApiEndPoints.shippmentOrder}?doPayment=false`,
            body: action.payload.data,
        });
        yield put(
            ShippmentOrderSuccess({
                shippmentOrder: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            ShippmentOrderFailure({
                errorShippmentOrder: e.response
                    ? e.response.data
                    : { status: 'FAILURE', message: 'Some error occurred!' },
            }),
        );
        store.addNotification({
            message: e.response && e.response.data && e.response.message,
            type: 'danger',
            insert: 'top',
            container: 'top-full',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
                duration: 3000,
                showIcon: true,
            },
        });
    }
}

//shippment order by customer id
function* getOrderByCustomerId(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints?.getOrderByCustomerId}/${action.payload.customerId}`,
            body: action.payload.data,
        });
        yield put(
            GetOrderByCustomerIdSuccess({
                getOrderByCustomerId: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            GetOrderByCustomerIdFailure({
                errorGetOrderByCustomerId: e.response
                    ? e.response.data
                    : { status: 'FAILURE', message: 'Some error occurred!' },
            }),
        );
    }
}

// get customer by username
function* getCustomer(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints?.getCustomer}${action.payload.username}`
                    : `${ApiEndPoints?.getCustomer}${action.payload.username}`,
        });

        if (response && response.data && response.data.data) {
            domainName === domainMap.T2
                ? localStorage.setItem('earthlinkCustomerDetail', JSON.stringify(response.data.data))
                : localStorage.setItem('customerDetail', JSON.stringify(response.data.data));
        }
        yield put(
            GetCustomerSuccess({
                getCustomer: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            GetCustomerFailure({
                errorGetCustomer: err.response ? err.response.data : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

// get customer by username
function* checkEmailAvailability(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.checkEmailAvailability}/${action.payload.emailId}`,
        });

        yield put(
            checkEmailAvailabilitySuccess({
                checkEmailAvailability: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            checkEmailAvailabilityFailure({
                errorCheckEmailAvailability: e.response && e.response.data,
            }),
        );
    }
}

// Update customer
function* updateCustomer(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'put',
            url: `${ApiEndPoints.updateCustomer}/${action.payload.customerId}`,
            body: action.payload.data,
        });
        yield put(
            UpdateCustomerSuccess({
                updateCustomer: response.data,
            }),
        );
        if (response && response.data && response.data.data) {
            domainName === domainMap.T2
                ? localStorage.setItem('earthlinkCustomerDetail', JSON.stringify(response.data.data))
                : localStorage.setItem('customerDetail', JSON.stringify(response.data.data));
        }
    } catch (e: any) {
        yield put(
            UpdateCustomerFailure({
                errorUpdateCustomer: e.response && e.response.data,
            }),
        );
    }
}

// Update secondary customer email
function* updateSecondaryCustomer(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'put',
            url: `/custsvc/${version}/customers/secondary/update`,
            body: action.payload,
        });
        yield put(
            UpdateSecondaryCustomerSuccess({
                updateSecondaryCustomer: response.data,
            }),
        );
    } catch (e: any) {
        // console.log(e.response)
        yield put(
            UpdateSecondaryCustomerFailure({
                errorUpdateSecondaryCustomer: e.response && e.response.data,
            }),
        );
    }
}

// Update customer source
function* updateCustomerSource(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'put',
            url: `${ApiEndPoints.updateCustomerSource}/${action.payload.customerId}`,
            body: action.payload.data,
        });
        yield put(
            UpdateCustomerSourceSuccess({
                updateCustomerSource: response.data,
            }),
        );
        if (response && response.data && response.data.data) {
            domainName === domainMap.T2
                ? localStorage.setItem('earthlinkCustomerDetail', JSON.stringify(response.data.data))
                : response.data.data.isPrimary
                ? localStorage.setItem('customerDetail', JSON.stringify(response.data.data))
                : localStorage.setItem('secondaryCustomerDetail', JSON.stringify(response.data.data));
        }
    } catch (e: any) {
        yield put(
            UpdateCustomerSourceFailure({
                errorUpdateCustomerSource: e.response && e.response.data,
            }),
        );
    }
}

// get coupon eligibility
function* eligibility(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `/catalogsvc/${version}/coupon/eligibility?emailId=${action.payload.emailId}`,
        });
        yield put(
            EligibilitySuccess({
                eligibility: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            EligibilityFailure({
                errorEligibility: e.response && e.response.data,
            }),
        );
    }
}

// check coupon code
function* coupon(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.coupon}/${action.payload.couponCode}`,
        });
        yield put(
            CouponSuccess({
                coupon: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            CouponFailure({
                errorCoupon: e.response && e.response.data,
            }),
        );
    }
}
// payment post api
function* payment(action: any) {
    try {
        const formData = new URLSearchParams();
        formData.append('emailId', action.payload.emailId);
        formData.append('redirectUrl', action.payload.redirectUrl);
        // formData.append('type', action.payload.type);
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${process.env.REACT_APP_PAYMENT_ADDRESS}/page/purchase/generate`,
            body: formData.toString(),
            auth: true,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        });
        yield put(
            PaymentSuccess({
                payment: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            PaymentFailure({
                errorPayment: e.response ? e.response.data : e.message,
            }),
        );
    }
}

// payment get api
function* paymentGet(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${process.env.REACT_APP_PAYMENT_ADDRESS}/account/redirect/page/${action.payload.id}`,
            auth: true,
        });
        yield put(
            PaymentGetSuccess({
                paymentGet: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            PaymentGetFailure({
                errorPaymentGet: e.response && e.response.data,
            }),
        );
    }
}

//Coupon reserve
function* couponReserve(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/catalogsvc/${version}/coupon/reserve/promo`,
            body: action.payload,
        });
        yield put(
            CouponReserveSuccess({
                couponReserve: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            CouponReserveFailure({
                errorCouponReserve: e.response && e.response.data,
            }),
        );
    }
}

function* ReachNumberSignup(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `/custsvc/${version}/customers/reachnumber/${action.payload.reachNumber}`,
        });
        yield put(
            ReachNumberSignupSuccess({
                reachNumberSignup: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            ReachNumberSignupFailure({
                errorReachNumberSignup: e.response && e.response.data,
            }),
        );
    }
}

//reset password
function* resetPassword(action: any) {
    console.log('action', action.payload);
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${ApiEndPoints.resetPassword}`,
            body: action.payload,
        });
        yield put(
            ResetPasswordSuccess({
                resetPasswordData: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            ResetPasswordFailure({
                errorResetPasswordData: e.response && e.response.data,
            }),
        );
    }
}

function* CheckoutSaga() {
    yield all([
        takeLatest(GET_STATE_CITY_BY_ZIPCODE, stateCityByZipcode),
        takeLatest(TAX_CALCULATION_BY_ADDRESS_TYPE1, taxCalculationByAddressType1),
        takeLatest(TAX_CALCULATION_BY_ADDRESS_TYPE2, taxCalculationByAddressType2),
        takeLatest(CREATE_CUSTOMER, createCustomer),
        takeLatest(GET_CUSTOMER, getCustomer),
        takeLatest(UPDATE_CUSTOMER, updateCustomer),
        takeLatest(CHECK_EMAIL_AVAILBLITY, checkEmailAvailability),
        takeLatest(UPDATE_SECONDARY_CUSTOMER, updateSecondaryCustomer),
        takeLatest(UPDATE_CUSTOMER_SOURCE, updateCustomerSource),
        takeLatest(ELIGIBILITY, eligibility),
        takeLatest(COUPON, coupon),
        takeLatest(PAYMENT, payment),
        takeLatest(PAYMENT_GET, paymentGet),
        takeLatest(COUPON_RESERVE, couponReserve),
        takeLatest(REACH_NUMBER_SIGNUP, ReachNumberSignup),
        takeLatest(SHIPPMENT_ORDER, shipmentOrder),
        takeLatest(RESET_PASSWORD, resetPassword),
        takeLatest(GET_ORDER_BY_CUSTOMER_ID, getOrderByCustomerId),
    ]);
}

export default CheckoutSaga;
